<template>
  <div class="column" :class="columnSize">
    <b-field
      :label="label"
      :horizontal="horizontal"
      :type="active ? 'is-info' : ''"
      :custom-class="active ? 'has-text-info' : ''"
    >
      <b-datepicker
        icon="calendar"
        size="is-small"
        placeholder="Select date"
        :date-formatter="date => formatDate(date)"
        :disabled="disabled"
        :value="datepickerValue"
        @input="onInput"
      >
        <b-button size="is-small" type="is-danger" @click="clear">
          <b-icon icon="close"></b-icon>
          <span>Clear</span>
        </b-button>
      </b-datepicker>
    </b-field>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    label: {
      type: String
    },
    value: {
      type: Date | String
    },
    active: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    columnSize: {
      type: Object | String,
      default: "is-12"
    }
  },
  computed: {
    datepickerValue() {
      return this.value
        ? new Date(moment(this.value).format("MM/DD/YYYY HH:mm:ss"))
        : null;
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update:value", moment(value).format("YYYY-MM-DD"));
    },
    clear() {
      this.$emit("input", "");
      this.$emit("update:value", "");
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldDatepicker.vue